import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-flex tw-flex-wrap tw-gap-xl" }
const _hoisted_2 = { class: "tw-w-full tw-flex-auto md:tw-max-w-260 tw-order-2 md:tw-order-1" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "tw-w-full tw-flex-auto md:tw-max-w-260 tw-order-1 md:tw-order-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "coffee-picker-sort",
  class: "sr-only"
}, "Sort Results By:", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: ""
}, "Sort by", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "tw-w-full tw-grid tw-grid-cols-1 lg:tw-grid-cols-6 tw-py-md tw-border-t tw-border-b tw-border-black" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["aria-labelledby"]
const _hoisted_11 = ["aria-label", "aria-pressed", "onClick"]
const _hoisted_12 = ["aria-label", "aria-pressed", "onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Filter Options "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "select select-variant select-picker",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPickerFilter())),
          "aria-label": "Open Filter Panel",
          "aria-expanded": _ctx.isFilterActive ? 'true' : 'false',
          "aria-controls": "filter-panel"
        }, " Filter by ", 8 /* PROPS */, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentSort) = $event)),
          class: "select-variant",
          id: "coffee-picker-sort",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSortChange && _ctx.onSortChange(...args)))
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sortOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: sortOption,
              value: sortOption
            }, _toDisplayString(sortOption), 9 /* TEXT, PROPS */, _hoisted_7))
          }), 128 /* KEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.currentSort]
        ])
      ])
    ]),
    _createCommentVNode(" / Filter Options "),
    _createCommentVNode(" Drop Down "),
    _createElementVNode("div", {
      class: _normalizeClass(["coffee-picker-dropdown tw-overflow-hidden", { 'tw-max-h-0 tw-hidden': !_ctx.isFilterActive, block: _ctx.isFilterActive }]),
      id: "filter-panel"
    }, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCategories, (filterCategory) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tw-w-full",
            key: filterCategory.name
          }, [
            _createElementVNode("h3", {
              class: "h6-small h6-small--filter tw-mb-10 tw-uppercase tw-text-grey",
              id: `filter_list_${filterCategory.name}`
            }, _toDisplayString(filterCategory.name), 9 /* TEXT, PROPS */, _hoisted_9),
            _createElementVNode("ul", {
              "aria-labelledby": `filter_list_${filterCategory.name}`
            }, [
              (_ctx.showAllFiltersIds.includes(filterCategory.property))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(filterCategory.filters, (filterOption) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: filterOption.name
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["tw-mb-10 h6 h6--filter", {
                  tag: filterCategory.name == 'Flavour',
                  'tag tag-black': filterOption.name == 'Black',
                  'tag tag-citrus': filterOption.name == 'Citrus',
                  'tag tag-cocoa': filterOption.name == 'Cocoa',
                  'tag tag-floral': filterOption.name == 'Floral',
                  'tag tag-fruity': filterOption.name == 'Fruity',
                  'tag tag-nutty': filterOption.name == 'Nutty',
                  'tag tag-spicy': filterOption.name == 'Spicy',
                  'tag tag-sweet': filterOption.name == 'Sweet',
                }]),
                        "aria-label": `Apply Filter: ${filterOption.name}`,
                        "aria-pressed": filterOption.active,
                        onClick: ($event: any) => (_ctx.toggleFilterOption(filterOption))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass({
                    'tw-bg-black tw-text-white tw-px-sm tw-py-xs tw-rounded-6 tw-flex tw-flex-row':
                      filterOption.active,
                  })
                        }, _toDisplayString(filterOption.name), 3 /* TEXT, CLASS */)
                      ], 10 /* CLASS, PROPS */, _hoisted_11)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.showAllFiltersIds.includes(filterCategory.property))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCategory.filters.slice(
                0,
                _ctx.filtersToShow
              ), (filterOption) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: filterOption.name
                      }, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["tw-mb-10 h6 h6--filter", {
                  tag: filterCategory.name == 'Flavour',
                  'tag tag-black': filterOption.name == 'Black',
                  'tag tag-citrus': filterOption.name == 'Citrus',
                  'tag tag-cocoa': filterOption.name == 'Cocoa',
                  'tag tag-floral': filterOption.name == 'Floral',
                  'tag tag-fruity': filterOption.name == 'Fruity',
                  'tag tag-nutty': filterOption.name == 'Nutty',
                  'tag tag-spicy': filterOption.name == 'Spicy',
                  'tag tag-sweet': filterOption.name == 'Sweet',
                }]),
                          "aria-label": `Apply Filter: ${filterOption.name}`,
                          "aria-pressed": filterOption.active,
                          onClick: ($event: any) => (_ctx.toggleFilterOption(filterOption))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({
                    'tw-bg-black tw-text-white tw-px-sm tw-py-xs tw-rounded-6 tw-flex tw-flex-row':
                      filterOption.active,
                  })
                          }, _toDisplayString(filterOption.name), 3 /* TEXT, CLASS */)
                        ], 10 /* CLASS, PROPS */, _hoisted_12)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (filterCategory.filters.length > _ctx.filtersToShow)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.toggleShowAllFilters(filterCategory))
                          }, " More (" + _toDisplayString(filterCategory.filters.length - _ctx.filtersToShow) + ") ", 9 /* TEXT, PROPS */, _hoisted_14)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_10)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 2 /* CLASS */),
    _createCommentVNode(" / Drop Down ")
  ], 64 /* STABLE_FRAGMENT */))
}